import api from './client'
import type { Comment } from '../types'

export const commentsApi = {
  listComments: (issueId: string) =>
    api.get<{ data: Comment[] }>(`/issues/${issueId}/comments`),

  createComment: (issueId: string, data: { content: string; isInternal: boolean }) =>
    api.post<{ data: Comment }>(`/issues/${issueId}/comments`, data),

  updateComment: (issueId: string, commentId: string, data: { content: string }) =>
    api.put<{ data: Comment }>(`/issues/${issueId}/comments/${commentId}`, data),

  deleteComment: (issueId: string, commentId: string) =>
    api.delete(`/issues/${issueId}/comments/${commentId}`),
}
